/* eslint-disable import/prefer-default-export */
import { put, takeLatest, select, call } from 'redux-saga/effects';
import { locales, setNotification } from 'utils';
import { push } from 'react-router-redux';
import {
    loadShippingTypeRes,
    loadShippingTypeErr,
    loadEditableShippingTypeRes,
    loadEditableShippingTypeErr,
    addShippingTypeRes,
    addShippingTypeErr,
    editShippingTypeRes,
    editShippingTypeErr,
} from '../actions/shippingTypeActions';
import {
    getShippingTypesApi,
    addShippingTypeApi,
    editShippingTypeApi,
    updateTranslateShippingTypeApi,
} from '../api/shippingTypeApi';

import * as ShippingTypeTypes from '../types/shippingTypeTypes';

const getLayout = state => state.layout;
const getShippingType = state => state.shippingType;

// L O A D   S H I P P I N G   T Y P E
function* loadShippingTypeSaga() {
    try {
        const shippingType = yield select(getShippingType);
        const { offset, limit } = shippingType;
        const params = {
            offset,
            limit,
        };

        const result = yield getShippingTypesApi(params);

        if (result.status === 200) {
            yield put(loadShippingTypeRes(result.data));
        } else {
            yield put(loadShippingTypeErr());
        }
    } catch (e) {
        yield put(loadShippingTypeErr());
        console.log(e);
    }
}

export function* loadShippingTypeWatcher() {
    yield takeLatest(ShippingTypeTypes.LOAD_SHIPPING_TYPE, loadShippingTypeSaga);
}
// L O A D   S H I P P I N G   T Y P E

// L O A D   E D I T A B L E   S H I P P I N G   T Y P E
function* loadEditableShippingTypeSaga(action) {
    try {
        const shippingType = yield select(getShippingType);
        const { offset, limit } = shippingType;

        const params = {
            offset,
            limit,
        };

        params.filter = JSON.stringify({ _id: action.id });

        const result = yield getShippingTypesApi(params);

        if (result.status === 200) {
            yield put(loadEditableShippingTypeRes(result.data));
        } else {
            yield put(loadEditableShippingTypeErr());
        }
    } catch (e) {
        yield put(loadEditableShippingTypeErr());
        console.log(e);
    }
}

export function* loadEditableShippingTypeWatcher() {
    yield takeLatest(ShippingTypeTypes.LOAD_EDITABLE_SHIPPING_TYPE, loadEditableShippingTypeSaga);
}
// L O A D   E D I T A B L E   S H I P P I N G   T Y P E

// U P D A T E   S H I P P I N G   T Y P E   T R A N S L A T E
function* updateShippingTypeTranslate(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;

    try {
        const data = {
            shipping_type_id: action.data[0].shipping_type_id,
            reseller_id: action.data[0].reseller_id,
        };

        const params = { bulk: [] };
        [...locales, 'de'].forEach((lc) => {
            if (lc !== 'en' || (lc === 'en' && action.type === 'EDIT_SHIPPING_TYPE')) {
                params.bulk.push({
                    ...data,
                    ...action.data[1][lc],
                });
            }
        });

        const result = yield updateTranslateShippingTypeApi(params);

        if (result.status !== 202) {
            setNotification('error', locale, 'global.error', 'shippingType.notification.translateError');
        }
    } catch (e) {
        setNotification('error', locale, 'global.error', 'shippingType.notification.translateError');
        console.log(e);
    }
}
// U P D A T E   S H I P P I N G   T Y P E   T R A N S L A T E

// E D I T   S H I P P I N G   T Y P E
function* editShippingTypeSaga(action) {
    try {
        const layout = yield select(getLayout);
        const { locale } = layout;
        const result = yield editShippingTypeApi(action.data[0]);

        if (result.status === 202) {
            yield call(updateShippingTypeTranslate, action);

            setNotification('success', locale, 'global.success', 'shippingType.notification.editShippingType.success');
            yield put(editShippingTypeRes());
            yield put(push('/settings/shipping-types'));
        } else {
            setNotification('error', locale, 'global.error', 'shippingType.notification.editShippingType.error');
            yield put(editShippingTypeErr());
        }
    } catch (e) {
        console.log(e);
        yield put(editShippingTypeErr());
    }
}
export function* editShippingTypeWatcher() {
    yield takeLatest(ShippingTypeTypes.EDIT_SHIPPING_TYPE, editShippingTypeSaga);
}
// E D I T   S H I P P I N G   T Y P E

// A D D   S H I P P I N G   T Y P E
function* addShippingTypeSaga(action) {
    try {
        const layout = yield select(getLayout);
        const { locale } = layout;
        const result = yield addShippingTypeApi(action.data[0]);

        if (result.status === 202) {
            yield call(updateShippingTypeTranslate, action);
            setNotification('success', locale, 'global.success', 'shippingType.notification.addShippingType.success');
            yield put(addShippingTypeRes());
            yield put(push('/settings/shipping-types'));
        } else {
            setNotification('error', locale, 'global.error', 'shippingType.notification.addShippingType.error');
            yield put(addShippingTypeErr());
        }
    } catch (e) {
        console.log(e);
        yield put(addShippingTypeErr());
    }
}
export function* addShippingTypeWatcher() {
    yield takeLatest(ShippingTypeTypes.ADD_SHIPPING_TYPE, addShippingTypeSaga);
}
// A D D   S H I P P I N G   T Y P E
